import React, { FC } from "react";
import AutoLayout from "@src/deprecatedDesignSystem/components/AutoLayout";
import { AnimatePresence, motion } from "framer-motion";

type Props = {
  position: "top" | "bottom";
  show: boolean;
};

const FadeOutToBlack: FC<Props> = (props) => {
  return (
    <AnimatePresence>
      {props.show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, type: "ease" }}
        >
          <AutoLayout
            height={44}
            style={{
              zIndex: 1,
              position: "absolute",
              top: props.position === "top" ? 0 : undefined,
              bottom: props.position === "bottom" ? 0 : undefined,
              transform:
                props.position === "bottom" ? "rotate(180deg)" : undefined,
              left: 0,
              right: 0,
              background:
                "linear-gradient(180deg, rgba(0, 0, 0, 0.2) -103.41%, rgba(0, 0, 0, 0) 100%)",
            }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FadeOutToBlack;
